<template>
  <div class="cano-index">
    <div class="index-main">
      <div class="index-banner">
        <router-link to="/evaluation">
          <img src="/Application/Home/Resource/static/images/mobile/index-banner_magic.png" alt="">
        </router-link>
      </div>
      <!-- 校友圈 -->
      <div class="cano-map">
        <div class="index-title">
          <div class="title-cn">凯诺校友圈</div>
          <div class="title-en">CANOPY ALUMNI NETWORK</div>
        </div>
        <div class="student-list">
          <div class="student-section" v-for="alumnus in alumnusData">
            <ul class="student-data">
              <li v-for="item in alumnus">
                <div class="school">{{item.school}}</div>
                <div class="student-count">{{item.num}}</div>
              </li>
            </ul>
          </div>
        </div>
        <div class="data-tips">
          *人均申请院校6所
        </div>
      </div>
      <!-- 专业设置 -->
      <div class="profession">
        <div class="index-title">
          <div class="title-cn">专业设置</div>
          <div class="title-en">ACADEMICS</div>
        </div>
        <div class="profession-swiper">
          <div class="swiper-nav">
            <div class="nav-item" :class="{'active': professionCurrentTab == 0}" @click="swipeProfession(0)">建筑景观方向</div>
            <div class="nav-item" :class="{'active': professionCurrentTab == 1}" @click="swipeProfession(1)">人机交互方向</div>
            <div class="nav-item" :class="{'active': professionCurrentTab == 2}" @click="swipeProfession(2)">艺术设计方向</div>
          </div>
          <div class="profession-swiper-main" id="professionSwiper">
            <div class="swiper-wrapper">
              <div class="swiper-slide">
                <div class="profession-card">
                  <div class="card-top space">
                    <div class="profession-name">建筑景观方向</div>
                    <div class="profession-eng-name">Space</div>
                  </div>
                  <div class="card-main">
                    <div class="sub-profession-list">
                      <div class="sub-profession-item">建筑<span>/ Architecture</span></div>
                      <div class="sub-profession-item">景观<span>/ Landscape Architecture</span></div>
                      <div class="sub-profession-item">城市设计<span>/ Urban Design</span></div>
                      <div class="sub-profession-item">城市规划<span>/ Urban Planning</span></div>
                      <div class="sub-profession-item">室内设计<span>/ Interior Architecture</span></div>
                    </div>
                  </div>
                  <div class="more-icon"></div>
                </div>
              </div>
              <div class="swiper-slide">
                <div class="profession-card">
                  <div class="card-top hci">
                    <div class="profession-name">人机交互方向</div>
                    <div class="profession-eng-name">HCI</div>
                  </div>
                  <div class="card-main">
                    <div class="sub-profession-list">
                      <div class="sub-profession-item">人机交互<span>/ Human Computer Interaction</span></div>
                      <div class="sub-profession-item">服务设计<span>/ Service Design</span></div>
                      <div class="sub-profession-item">用户体验设计<span>/ User Experience Design</span></div>
                      <div class="sub-profession-item">交互设计<span>/ Interaction Design</span></div>
                    </div>
                  </div>
                  <div class="more-icon"></div>
                </div>
              </div>
              <div class="swiper-slide">
                <div class="profession-card">
                  <div class="card-top art">
                    <div class="profession-name">艺术设计方向</div>
                    <div class="profession-eng-name">ART</div>
                  </div>
                  <div class="card-main">
                    <div class="sub-profession-list">
                      <div class="sub-profession-item">视觉传达<span>/ Visual Communication</span></div>
                      <div class="sub-profession-item">工业设计<span>/ Industrial Design</span></div>
                      <div class="sub-profession-item">艺术管理<span>/ Art Administration</span></div>
                    </div>
                  </div>
                  <div class="more-icon"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 讲师 -->
      <div class="teacher">
        <div class="teacher-image-wall">
          <img src="https://canopy.oss-cn-beijing.aliyuncs.com/minipgm/about-teacher.png">
        </div>
        <div class="teacher-main">
          <div class="more-teacher">
            <router-link class="more-button" to="/lecturer">查看全部师资</router-link>
          </div>
          <div class="teacher-rule">
            <div class="rule-wrapper">
              <div class="rule-container">
                <div class="rule-title">严格的讲师筛选制度</div>
                <div class="sub-rule-title"><span>师资和课程质量的严格追求</span><span>是凯诺的核心竞争力</span></div>
                <div class="rule-list">
                  <div class="rule-item">
                    <div class="rule-icon"><img src="https://canopy.oss-cn-beijing.aliyuncs.com/minipgm/about-icon-earth.png"></div>
                    <div class="rule-text">讲师来自其所在地区<span class="cano">Top5</span>院校</div>
                  </div>
                  <div class="rule-item">
                    <div class="rule-icon"><img src="https://canopy.oss-cn-beijing.aliyuncs.com/minipgm/about-icon-medal.png"></div>
                    <div class="rule-text">具备丰富实践经验</div>
                  </div>
                  <div class="rule-item">
                    <div class="rule-icon"><img src="https://canopy.oss-cn-beijing.aliyuncs.com/minipgm/about-icon-book.png"></div>
                    <div class="rule-text">多位讲师获得注册建筑师、规划师<span class="cano">行业资格</span></div>
                  </div>
                  <div class="rule-item">
                    <div class="rule-icon"><img src="https://canopy.oss-cn-beijing.aliyuncs.com/minipgm/about-icon-company.png"></div>
                    <div class="rule-text">职业背景覆盖<span class="cano">SOM、隈研吾、福斯特、Google等</span>各大知名设计事务所或互联网公司</div>
                  </div>
                  <div class="rule-item">
                    <div class="rule-icon"><img src="https://canopy.oss-cn-beijing.aliyuncs.com/minipgm/about-icon-app.png"></div>
                    <div class="rule-text">申请讲师需<span class="cano">通过初筛、面试、试讲、岗前培训等</span>严格流程才可成为讲师</div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
      <!-- 优势 -->
      <div class="advantage">
        <div class="index-title white">
          <div class="title-cn">我们的优势</div>
          <div class="title-en">PIONEER OF DESIGN EDUCATION</div>
        </div>
        <div class="advantage-list">
          <div class="advantage-item">
            <div class="advantage-icon"><img src="https://canopy.oss-cn-beijing.aliyuncs.com/minipgm/about-pioneer-icon1.png"></div>
            <div class="advantage-title">260+海外名校讲师</div>
          </div>
          <div class="advantage-item">
            <div class="advantage-icon"><img src="https://canopy.oss-cn-beijing.aliyuncs.com/minipgm/about-pioneer-icon4.png"></div>
            <div class="advantage-title">Studio设计室国际化教学</div>
          </div>
          <div class="advantage-item">
            <div class="advantage-icon"><img src="https://canopy.oss-cn-beijing.aliyuncs.com/minipgm/about-pioneer-icon2.png"></div>
            <div class="advantage-title">10年设计教学模式</div>
          </div>
          <div class="advantage-item">
            <div class="advantage-icon"><img src="https://canopy.oss-cn-beijing.aliyuncs.com/minipgm/about-pioneer-icon3.png"></div>
            <div class="advantage-title">2000+凯诺校友</div>
          </div>
          <div class="advantage-item">
            <div class="advantage-icon"><img src="https://canopy.oss-cn-beijing.aliyuncs.com/minipgm/about-pioneer-icon5.png"></div>
            <div class="advantage-title">多样化课程选择</div>
          </div>
          <div class="advantage-item">
            <div class="advantage-icon"><img src="https://canopy.oss-cn-beijing.aliyuncs.com/minipgm/about-pioneer-icon6.png"></div>
            <div class="advantage-title">学术出版</div>
          </div>
        </div>
      </div>
      <!-- 课程 -->
      <!-- <div class="courses">
        <div class="index-title">
          <div class="title-cn">课程体系</div>
          <div class="title-en">CURRICULUM STRUCTURE</div>
        </div>
        <div class="courses-cards-list" id="coursesSwiper">
          <div class="swiper-wrapper">
            <div class="swiper-slide courses-card oneonone">
              <div class="course-title">一对一 / One-on-One</div>
              <div class="courses-intro">
                <div>主带老师+邀约老师</div>
                <div>多位讲师与学生一对一教学</div>
                <div>讲师来自海外设计院校、世界知名事务所</div>
              </div>
            </div>
            <div class="swiper-slide courses-card seminar">
              <div class="course-title">小组课 / Seminar</div>
              <div class="courses-intro">
                <div>2-16 人直播小班课</div>
                <div>课堂内容当堂消化</div>
                <div>从分析到表现、从网申到面试，丰富技能库</div>
              </div>
            </div>
            <div class="swiper-slide courses-card studio">
              <div class="course-title">设计室 / Studio</div>
              <div class="courses-intro">
                <div>领先Studio线上教学模式</div>
                <div>从无到有生成完整设计方案</div>
                <div>教学作品被清华出版社等学术出版机构收录</div>
                <div>屡获国际大奖</div>
              </div>
            </div>
            <div class="swiper-slide courses-card essay">
              <div class="course-title">文书 / PS/CV/Essay</div>
              <div class="courses-intro">
                <div>文书一对一指导+深改+校订</div>
                <div>专业设计师为你拓展设计思路</div>
                <div>学生评价文书课“颠覆思想”</div>
              </div>
            </div>
            <div class="swiper-slide courses-card public">
              <div class="course-title">公开课 / Open Lecture</div>
              <div class="courses-intro">
                <div>累计数万人参与</div>
                <div>搭建起无疆界的设计交流平台</div>
              </div>
            </div>
          </div>
          <div class="swiper-pagination"></div>
        </div>
      </div> -->
      <!-- 奇想 -->
      <div class="book">
        <div class="index-title">
          <div class="title-cn">凯诺学术出版</div>
          <div class="title-en">挑战对设计思考的桎梏</div>
        </div>
        <div class="book-intro">
          <div class="book-cover">
            <img src="https://canopy.oss-cn-beijing.aliyuncs.com/minipgm/about-book-cover.png">
          </div>
          <div class="book-intro-text">我们强调学术研究和设计知识的传播。<span class="strong">凯诺与清华大学出版社、琢磨琢磨达成战略合作</span>，学术出版物<span class="cano strong">《新设计书·奇想1》</span>（2016年）和<span class="cano strong">《奇想·建筑》</span>（2018年）已由清华大学出版社发行，先进教学实践模式曾被台湾一线建筑学期刊杂志《建筑师》（2018年6月刊）专题报道。</div>
        </div>
        <div class="unite-recommend">
          <div class="recommend-title">联合推荐</div>
          <div class="recommend-wrapper">
            <div class="recommend-card">
              <div class="avatar"><img src="https://canopy.oss-cn-beijing.aliyuncs.com/minipgm/about-book-avatar1.jpg"></div>
              <div class="content">
                <div class="name">Michael Sorkin</div>
                <div class="personal-title"><span>迈克尔·索金事务所主持建筑师</span>建筑师，作家，教育家</div>
              </div>
            </div>
            <div class="recommend-card">
              <div class="avatar"><img src="https://canopy.oss-cn-beijing.aliyuncs.com/minipgm/about-book-avatar2.jpg"></div>
              <div class="content">
                <div class="name">宋晔皓</div>
                <div class="personal-title"><span>清华大学建筑系教授</span>清华大学建筑学院建筑与技术研究所所长</div>
              </div>
            </div>
            <div class="recommend-card">
              <div class="avatar"><img src="https://canopy.oss-cn-beijing.aliyuncs.com/minipgm/about-book-avatar3.jpg"></div>
              <div class="content">
                <div class="name">Jerry Wells</div>
                <div class="personal-title"><span>康奈尔大学终身教授</span>曾任康奈尔大学建筑学院院长</div>
              </div>
            </div>
            <div class="recommend-card">
              <div class="avatar"><img src="https://canopy.oss-cn-beijing.aliyuncs.com/minipgm/about-book-avatar4.png"></div>
              <div class="content">
                <div class="name">宋刚</div>
                <div class="personal-title"><span>竖梁社主持建筑师</span>华南理工大学建筑学院教师</div>
              </div>
            </div>
          </div>
          <div class="public-book">
            <div class="recommend-title">权威学术出版机构出版</div>
            <div class="public-company"><img class="" src="https://canopy.oss-cn-beijing.aliyuncs.com/minipgm/public-company.png"></div>
          </div>
          <div class="check-detail">
            <router-link class="more-button" to="/book">查看详情</router-link>
          </div>
        </div>
      </div>
      <router-link class="evaluation-card" to="/evaluation"><img src="/Application/Home/Resource/static/images/mobile/index-evaluation-card_magic.png" alt=""></router-link>
    </div>
    <Footer></Footer>
  </div>
</template>

<style lang="less" scoped>
@img-path: '/Application/Home/Resource/static/images/mobile/';
@cano: #4DA2C7;
.index-main{
  .index-title{
    text-align: center;
    .title-cn{
      font-size: 20px;
      line-height: 20px;
      color: #333;
      font-weight: 500;
    }
    .title-en{
      margin-top: 8px;
      font-size: 14px;
      line-height: 14px;
      color: @cano;
    }
    &.white{
      .title-cn,
      .title-en{
        color: #FFF;
      }
    }
  }
  .more-button{
    width: 195px;
    height: 42px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 0;
    border-radius: 42px;
    color: #FFF;
    font-size: 14px;
    font-weight: bold;
    background: linear-gradient(270deg, #2B7CEB 0%, #58BAEA 100%);
    transition: all .2s;
    &:active{
      opacity: .8;
    }
  }
  .index-banner{
    width: 100%;
    img{
      width: 100%;
    }
  }
  .cano-map{
    margin-top: 36px;
    width: 100%;
    background: url('https://canopy.oss-cn-beijing.aliyuncs.com/minipgm/about-alumni-bg.png') no-repeat center 4px #FFF;
    background-size: cover;
    .student-list{
      margin-top: 24px;
      overflow-x: auto;
      white-space: nowrap;
      .student-section{
        display: inline-block;
        vertical-align: top;
        width: 152px;
        height: 200px;
        border-radius: 4px 4px 8px 8px;
        box-shadow: 0px -20px 50px 0px rgba(77, 162, 199, 0.1);
        background: #FFF;
        margin-left: 10px;
        padding: 16px;
        &:first-child{
          margin-left: 16px;
        }
        &:last-child{
          margin-right: 16px;
        }
        li{
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 12px;
          line-height: 24px;
          color: #333;
          font-weight: bold;
        }
      }
    }
    .data-tips{
      margin-top: 20px;
      padding: 0 16px 20px;
      font-size: 12px;
      line-height: 18px;
      color: #999;
    }
  }
  .profession{
    margin-top: 36px;
    padding-bottom: 24px;
    .swiper-nav{
      margin-top: 24px;
      display: flex;
      padding: 0 34px;
      justify-content: space-between;
      align-items: flex-start;
      font-size: 13px;
      color: #666;
      font-weight: bold;
      .nav-item{
        position: relative;
        padding: 0 10px;
        height: 27px;
        display: flex;
        justify-content: center;
        color: #666;
        font-size: 13px;
        line-height: 13px;
        font-weight: bold;
        transition: all .2s;
        &::after{
          content: '';
          position: absolute;
          bottom: -6px;
          left: 50%;
          transform: translateX(-50%);
          width: 0;
          height: 0;
          border-width: 6px 4px;
          border-style: solid dashed dashed dashed;
          border-color: transparent;
        }
        &.active{
          color: @cano;
          &::after{
            border-color: rgba(77, 162, 199, 0.6) transparent transparent transparent;
          }
        }
      }
    }
    .profession-swiper-main{
      margin-top: 11px;
      .swiper-slide{
        padding: 0 24px;
        .profession-card{
          position: relative;
          width: 100%;
          background: #FFF;
          border-radius: 6px;
          overflow: hidden;
          box-shadow: 0px 20px 50px 0px rgba(77,162,199,0.1);
          .card-top{
            height: 110px;
            box-sizing: border-box;
            padding: 0 25px;
            display: flex;
            justify-content: center;
            align-items: flex-start;
            flex-direction: column;
            &.space{
              background: url('https://canopy.oss-cn-beijing.aliyuncs.com/minipgm/about-academic-space.png') no-repeat center center;
              background-size: cover;
            }
            &.hci{
              background: url('https://canopy.oss-cn-beijing.aliyuncs.com/minipgm/about-academic-hci.png') no-repeat center center;
              background-size: cover;
            }
            &.art{
              background: url('https://canopy.oss-cn-beijing.aliyuncs.com/minipgm/about-academic-art.png') no-repeat center center;
              background-size: cover;
            }
            .profession-name{
              font-size: 18px;
              line-height: 18px;
              color: #FFF;
              font-weight: bold;
            }
            .profession-eng-name{
              margin-top: 8px;
              font-size: 18px;
              line-height: 18px;
              color: rgba(255,255,255,0.5);
              font-weight: bold;
            }
          }
          .card-main{
            position: relative;
            border-radius: 6px;
            background: #FFF;
            transform: translateY(-8px);
            height: 234px;
            padding: 21px 0 0 24px;
            .sub-profession-item{
              font-size: 14px;
              line-height: 14px;
              font-weight: bold;
              color: #666;
              margin-bottom: 28px;
              display: flex;
              span{
                margin-left: 6px;
                font-weight: normal;
                color: #999;
              }
            }
          }
          .more-icon{
            position: absolute;
            bottom: 14px;
            right: 8px;
            width: 32px;
            height: 22px;
            background: url('https://canopy.oss-cn-beijing.aliyuncs.com/minipgm/about-icon-more.png') no-repeat top center;
            background-size: cover;
          }
        }
      }
    }
  }
  .teacher{
    .teacher-image-wall{
      width: 100%;
      img{
        width: 100%;
      }
    }
    .teacher-main{
      width: 100%;
      background: url('https://canopy.oss-cn-beijing.aliyuncs.com/minipgm/about-teacher-bg.png') no-repeat top center;
      background-size: cover;
      padding-bottom: 40px;
      .more-teacher{
        padding-top: 24px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .teacher-rule{
        padding: 0 15px;
        margin-top: 56px;
        .rule-wrapper{
          position: relative;
          width: 3.24rem;
          &::after{
            content: '';
            position: absolute;
            top: -20px;
            right: -20px;
            width: 100%;
            height: 100%;
            background: linear-gradient(270deg,rgba(43,124,235,1) 0%,rgba(88,186,234,1) 100%);
            z-index: 8;
          }
        }
        .rule-container{
          position: relative;
          width: 3.24rem;
          box-sizing: border-box;
          background: #FFF;
          padding: 28px 22px 28px 17px;
          background: #FFF;
          z-index: 10;
          .rule-title{
            margin-left: 20px;
            text-align: center;
            font-size: 20px;
            line-height: 20px;
            color: #333;
            font-weight: bold;
          }
          .sub-rule-title{
            margin: 12px 0 0 20px;
            text-align: center;
            font-size: 14px;
            line-height: 20px;
            color: #4DA2C7;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
          }
          .rule-list{
            .rule-item{
              display: flex;
              justify-content: flex-start;
              align-items: flex-start;
              margin-top: 20px;
              .rule-icon{
                width: 20px;
                height: 20px;
                flex-shrink: 0;
                transform: translateY(-4rpx);
                img{
                  width: 100%;
                }
              }
              .rule-text{
                margin-left: 10px;
                font-size: 13px;
                line-height: 20px;
                font-weight: bold;
                color: #333;
              }
            }
          }
        }
      }
    }
  }
  .advantage{
    background: url('https://canopy.oss-cn-beijing.aliyuncs.com/minipgm/about-pioneer-bg.png') no-repeat top center;
    background-size: cover;
    padding: 29px .15rem 23px;
    .advantage-list{
      margin-top: 20px;
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      flex-wrap: wrap;
      .advantage-item{
        padding-top: .08rem;
        background: #FFF;
        width: 1.66rem;
        height: 1.4rem;
        margin-right: .12rem;
        margin-bottom: .16rem;
        box-shadow: 0 4px 16px 0 rgba(13,44,58,0.2);
        border-radius: 6px;
        &:nth-child(2n){
          margin-right: 0;
        }
        .advantage-icon{
          width: 1rem;
          height: 1rem;
          margin: 0 auto;
          img{
            width: 100%;
          }
        }
        .advantage-title{
          text-align: center;
          margin-top: .03rem;
          font-size: 13px;
          line-height: 13px;
          color: #333;
          font-weight: bold;
        }
      }
    }
  }
  .courses{
    padding: .36rem 0 .44rem;
    .courses-cards-list{
      margin-top: .24rem;
      padding: 0 .15rem;
      position: relative;
      .swiper-wrapper{
        padding-right: .15rem;
      }
    }
    .courses-card{
      flex-shrink: 0;
      width: 2.92rem;
      box-sizing: border-box;
      height: 1.66rem;
      color: #FFF;
      padding: 29px 20px 0;
      box-shadow: 0 4px 17px 0 rgba(13, 44, 58, 0.4);
      &.oneonone{
        background: url('https://canopy.oss-cn-beijing.aliyuncs.com/minipgm/about-courses-oneonone.png') no-repeat center center;
        background-size: cover;
      }
      &.seminar{
        background: url('https://canopy.oss-cn-beijing.aliyuncs.com/minipgm/about-courses-seminar.png') no-repeat center center;
        background-size: cover;
      }
      &.studio{
        background: url('https://canopy.oss-cn-beijing.aliyuncs.com/minipgm/about-courses-studio.png') no-repeat center center;
        background-size: cover;
      }
      &.essay{
        background: url('https://canopy.oss-cn-beijing.aliyuncs.com/minipgm/about-courses-essay.png') no-repeat center center;
        background-size: cover;
      }
      &.public{
        background: url('https://canopy.oss-cn-beijing.aliyuncs.com/minipgm/about-courses-open-lecture.png') no-repeat center center;
        background-size: cover;
      }
      .course-title{
        font-size: 14px;
        line-height: 14px;
        font-weight: bold;
      }
      .courses-intro{
        margin-top: 12px;
        font-size: 12px;
        line-height: 22px;
        color: rgba(255,255,255,0.7);
      }
    }
  }
  .book{
    width: 100%;
    padding: 32px 0 20px;
    background: url('@{img-path}achievement-bg.jpg') no-repeat center center;
    background-size: cover;
    .book-intro{
      display: flex;
      justify-content: center;
      align-items: flex-start;
      margin-top: 20px;
      .book-cover{
        width: 143px;
        padding: 0 10px;
        flex-shrink: 0;
        img{
          width: 100%;
        }
      }
      .book-intro-text{
        margin-left: 12px;
        width: 180px;
        font-size: 12px;
        line-height: 20px;
        color: #333;
        .cano{
          color: @cano;
        }
        .strong{
          font-weight: bold;
        }
      }
    }
    .unite-recommend{
      margin-top: 20px;
      padding: 0 24px;
      .recommend-title{
        font-size: 16px;
        line-height: 16px;
        font-weight: bold;
        color: #333;
      }
      .recommend-wrapper{
        background: #FFF;
        margin-top: 14px;
        border-radius: 3px;
        box-shadow: 0px 2px 16px 0px rgba(0, 0, 0, 0.05);
        padding: 0 12px;
        .recommend-card{
          padding: 12px 0;
          border-bottom: 1px solid #EEE;
          display: flex;
          align-items: flex-end;
          .avatar{
            width: .6rem;
            height: .6rem;
            img{
              width: 100%;
            }
          }
          .content{
            padding-left: 12px;
            .name{
              font-size: 13px;
              line-height: 13px;
              font-weight: bold;
              color: #333;
            }
            .personal-title{
              font-size: 12px;
              line-height: 18px;
              margin-top: 7px;
              span{
                display: block;
              }
            }
          }
        }
      }
      .public-book{
        margin-top: 24px;
        .public-company{
          margin-top: .1rem;
          height: .26rem;
          img{
            height: 100%;
          }
        }
      }
      .check-detail{
        margin-top: 32px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }
  .evaluation-card{
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    img{
      width: 100%;
    }
  }
}
</style>

<style lang="less">
  @cano: #4DA2C7;
  #coursesSwiper{
    .swiper-pagination{
      display: flex;
      justify-content: center;
      bottom: -20px;
      .swiper-pagination-bullet{
        width: 4px;
        height: 4px;
        margin: 0 3px;
      }
      .swiper-pagination-bullet-active{
        background: @cano;
      }
    }
  }
</style>

<script>
import Swiper, { Navigation, Pagination, Autoplay } from 'swiper'
import Footer from '@/components/Common/footer.vue'
import Utils from '@/untils/utils'
import 'swiper/swiper-bundle.css'
export default {
  data() {
    return {
      // 校友圈数据
      alumnusData: [
        [
          {school: 'Harvard',num: 103},
          {school: 'Yale',num: 42},
          {school: 'MIT',num: 11},
          {school: 'Princeton',num: 11},
          {school: 'Cornell',num: 127},
          {school: 'UPenn',num: 334},
          {school: 'Columbia',num: 256},
        ],
        [
          {school: 'UCB',num: 158},
          {school: 'RISD',num: 192},
          {school: 'Cooper Union',num: 8},
          {school: 'UMich',num: 187},
          {school: 'UVA',num: 109},
          {school: 'CMU',num: 43},
          {school: 'WUSTL',num: 398},
        ],
        [
          {school: 'Pratt',num: 53},
          {school: 'UCLA',num: 235},
          {school: 'Rice',num: 53},
          {school: 'SCI-Arc',num: 102},
          {school: 'USC',num: 248},
          {school: 'UCL',num: 142},
          {school: 'AA',num: 102},
        ],
        [
          {school: 'RCA',num: 12},
          {school: 'Edinburgh',num: 95},
          {school: 'Sheffield',num: 102},
          {school: 'Liverpool',num: 51},
          {school: 'Cardiff',num: 73},
          {school: 'Glasgow',num: 24},
          {school: 'U of Nottingham',num: 36},
        ],
        [
          {school: 'UAL',num: 22},
          {school: 'TUD',num: 101},
          {school: 'POLIMI',num: 132},
          {school: 'KTH',num: 145},
          {school: 'TU/e',num: 53},
          {school: 'Aalto',num: 11},
          {school: 'AHO',num: 28},
        ],
        [
          {school: 'KU Leuven',num: 9},
          {school: 'TUM',num: 12},
          {school: 'TU Dresden',num: 16},
          {school: 'TU Darmstadt',num: 11},
          {school: 'RWTH Aachen',num: 19},
          {school: 'TU Braunschweig',num: 13},
          {school: 'Uni-Hannover',num: 21},
        ],
        [
          {school: 'UBC',num: 34},
          {school: 'HKU',num: 136},
          {school: 'NUS',num: 79},
          {school: 'CUHK',num: 163},
          {school: 'Tokyo U',num: 36},
          {school: 'Tokyo Tech',num: 42},
          {school: 'Waseda',num: 45},
        ],
        [
          {school: 'U of Toronto',num: 42},
          {school: 'Sydney U  ',num: 83},
          {school: 'U of Melbourne',num: 76},
          {school: 'RMIT',num: 68},
        ]
      ],
      // 专业轮播实例
      academicsSwiper: null,
      professionCurrentTab: 0,
      // 课程设置轮播实例
      coursesSwiper: null,
    }
  },
  components: {
    Footer
  },
  created() {
    this.$store.commit('setActiveMenu', 'index');
  },
  mounted() {
    Swiper.use([Navigation, Pagination, Autoplay]);
    let _self = this;
    this.academicsSwiper = new Swiper('#professionSwiper', {
      autoplay: {
        delay: 4000,
        stopOnLastSlide: false,
        disableOnInteraction: true,
      },
      on: {
        slideChangeTransitionEnd() {
          _self.professionCurrentTab = this.activeIndex;
        }
      }
    });
    this.coursesSwiper = new Swiper('#coursesSwiper', {
      slidesPerView: 'auto',
      spaceBetween: 20,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
    });
  },
  methods: {
    swipeProfession(index) {
      this.professionCurrentTab = index;
      this.academicsSwiper.slideTo(index);
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Index/index.vue